import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { COLLAPSED_DRAWER, FIXED_DRAWER, HORIZONTAL_NAVIGATION, INSIDE_THE_HEADER } from 'constants/ActionTypes';
import SearchBox from 'components/SearchBox';
import AppNotification from '../AppNotification/index';
import CardHeader from 'components/dashboard/Common/CardHeader/index';
import { switchLanguage, toggleCollapsedNav } from 'actions/Setting';
import IntlMessages from 'util/IntlMessages';
import LanguageSwitcher from 'components/LanguageSwitcher/index';
import UserInfo from 'components/UserInfo';
import Menu from 'components/Header/Menu';
import { isSuperUser } from 'services/Authentication';
import { TIGHT_FIT_PARAM } from 'constants/System';

class Header extends React.Component {
    onAppNotificationSelect = () => {
        this.setState({
            appNotification: !this.state.appNotification,
        });
    };

    onUserInfoSelect = () => {
        this.setState({
            userInfo: !this.state.userInfo,
        });
    };

    onLangSwitcherSelect = () => {
        this.setState({
            langSwitcher: !this.state.langSwitcher,
        });
    };
    onSearchBoxSelect = () => {
        this.setState({
            searchBox: !this.state.searchBox,
        });
    };
    handleRequestClose = () => {
        this.setState({ langSwitcher: false, mailNotification: false, appNotification: false, searchBox: false });
    };
    onToggleCollapsedNav = () => {
        const val = !this.props.navCollapsed;
        this.props.toggleCollapsedNav(val);
    };
    onDisplayProfileDetails = () => {
        this.setState({ viewProfileDetails: true });
    };

    constructor() {
        super();
        this.state = {
            searchBox: false,
            searchText: '',
            mailNotification: false,
            langSwitcher: false,
            appNotification: false,
            userInfo: false,
        };
    }

    updateSearchText(evt) {
        this.setState({
            searchText: evt.target.value,
        });
    }

    getHeaderDetails = () => {
        const { selectedOrg } = this.props;
        let headerDetail = ' (You are currently impersonating this organisation)';
        if (isSuperUser()) {
            if (selectedOrg?.name) {
                headerDetail = selectedOrg?.name.concat(headerDetail);
            } else {
                headerDetail = 'NONE SELECTED YET'.concat(headerDetail);
            }
            return headerDetail;
        }
        return '';
    };

    render() {
        const { drawerType, locale, navigationStyle, horizontalNavPosition, width } = this.props;
        const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'd-flex d-xl-none' : drawerType.includes(COLLAPSED_DRAWER) ? 'd-flex' : 'd-none';
        const headerMarginLeft = width > TIGHT_FIT_PARAM ? 'ml-5' : 'ml-1';

        return (
            <div className="app-main-header">
                <div className="d-flex app-toolbar align-items-center">
                    {navigationStyle === HORIZONTAL_NAVIGATION ? (
                        <div className="app-logo-bl">
                            <div className="d-block d-md-none">
                                <span className="jr-menu-icon" onClick={this.onToggleCollapsedNav}>
                                    <span className="menu-icon" />
                                </span>
                            </div>
                            <div className="app-logo pointer d-none d-md-block">
                                <img className="d-none d-lg-block" alt="..." src="http://via.placeholder.com/105x36" />
                                <img className="d-block d-lg-none mr-3" alt="..." src="http://via.placeholder.com/32x32" />
                            </div>
                        </div>
                    ) : (
                        <span className={`jr-menu-icon pointer ${drawerStyle}`} onClick={this.onToggleCollapsedNav}>
                            <span className="menu-icon" />
                        </span>
                    )}
                    <div className={headerMarginLeft} style={{
                        fontWeight: '700',
                        fontSize: '1.25rem',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}>
                        {this.getHeaderDetails()}
                    </div>
                    {/* <SearchBox styleName="d-none d-lg-block"
                               onChange={this.updateSearchText.bind(this)}
                               value={this.state.searchText}/> */}
                    {navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === INSIDE_THE_HEADER && <Menu />}

                    <ul className="header-notifications list-inline ml-auto">
                        <li className="d-inline-block d-lg-none list-inline-item">
                            <Dropdown className="quick-menu nav-searchbox" isOpen={this.state.searchBox} toggle={this.onSearchBoxSelect.bind(this)}>
                                <DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
                                    <span className="icon-btn size-30">
                                        <i className="zmdi zmdi-search zmdi-hc-fw" />
                                    </span>
                                </DropdownToggle>

                                <DropdownMenu right className="p-0">
                                    <SearchBox styleName="search-dropdown" placeholder="" onChange={this.updateSearchText.bind(this)} value={this.state.searchText} />
                                </DropdownMenu>
                            </Dropdown>
                        </li>
                        <li className="list-inline-item">
                            <Dropdown className="quick-menu" isOpen={this.state.langSwitcher} toggle={this.onLangSwitcherSelect.bind(this)}>
                                <DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
                                    <div className="d-flex align-items-center pointer">
                                        <i className={`flag flag-24 flag-${locale.icon}`} />
                                    </div>
                                </DropdownToggle>

                                <DropdownMenu right className="w-50">
                                    <LanguageSwitcher switchLanguage={this.props.switchLanguage} handleRequestClose={this.handleRequestClose} />
                                </DropdownMenu>
                            </Dropdown>
                        </li>
                        <li className="list-inline-item app-tour">
                            <Dropdown className="quick-menu" isOpen={this.state.appNotification} toggle={this.onAppNotificationSelect.bind(this)}>
                                <DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
                                    <span className="icon-btn size-20 font-size-16">
                                        <i className="zmdi zmdi-notifications-active zmdi-hc-lg icon-alert" />
                                    </span>
                                </DropdownToggle>

                                <DropdownMenu right>
                                    <CardHeader styleName="align-items-center" heading={<IntlMessages id="appNotification.title" />} />
                                    <AppNotification />
                                </DropdownMenu>
                            </Dropdown>
                        </li>
                        <li className="list-inline-item user-nav">
                            <Dropdown className="quick-menu" isOpen={this.state.userInfo} toggle={this.onUserInfoSelect.bind(this)}>
                                <DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
                                    <img alt="..." src="assets/images/person-150_150.jpg" className="pointer user-avatar size-30" />
                                </DropdownToggle>

                                <DropdownMenu right>
                                    <UserInfo />
                                </DropdownMenu>
                            </Dropdown>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ settings, orgs }) => {
    const { drawerType, locale, navigationStyle, horizontalNavPosition, width } = settings;
    const { selectedOrg } = orgs;
    return { drawerType, locale, navigationStyle, horizontalNavPosition, selectedOrg, width };
};

export default withRouter(connect(mapStateToProps, { toggleCollapsedNav, switchLanguage })(Header));



// WEBPACK FOOTER //
// ./components/Header/index.js